const getDefaultState = () => {
  return {
    sales: [],
    setSalesCSError: null,
    filters: {},
    loading: false,
    loadingLeads: false,
    isCorreios: false,
    salesPaid: 0,
    salesTotal: 0,
    salesDesqualify: 0,
    salesDesqualifyDeb: 0,
    salesDay: [],
    subscriptions: [],
    qualifications: [],
    contracts: [],
    contractsNotSign: [],
    active: [],
    canceled: [],
    disqualified: [],
    leadsBySeller: [],
    leads: [],
    plans: [],
    filtered_plans: [],
    subclasses: [],
    sellers: [],
    seller: null,
    reSubscription: false,
  };
};

const otherState = () => {
  return {
    lead: null,
    consumer_unit_uploaded: null,
    file: [],
    plan: null,
    coupon: null,
    user: {
      cpf: null,
      name: null,
      email: "",
      phone: null,
      ID_document: null,
      average_consumption: 0,
      utility_company: "cemig",
      person_type: "pf",
      payment_type: "boleto",
      enercred_contract: true,
      address: {
        contry: {
          initials: "br",
          name: "Brasil",
        },
      },
      promo_code: null,
      signedcontract_by: null,
    },
    qualifications_form: [],
    proposal_validation: {
      cpf_valid: false,
      cpf_duplicated: false,
      can_subscription: true,
      ucs: [],
      email_found: null,
      financial_pending: false,
      same_email: false,
    },
  };
};

// initial state
const state = { ...getDefaultState(), ...otherState() };

export default {
  getDefaultState,
  otherState,
  ...state,
};
